import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SignInResponseData } from '@shared/model/sign-in-response-data.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly baseUrl = environment.baseUrl;
  private readonly routePrefix = 'api/v1/admin/auth';

  constructor( private http: HttpClient , private snackBar: MatSnackBar) { }

  signIn(credential: any): Observable<SignInResponseData> {
    return this.http.post(
      `${this.baseUrl}/${this.routePrefix}/sign-in`, credential).pipe(map(
        (res: any) => {
          if (res.statusCode === 200) {
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
            return res.dataF
          } else {
          this.snackBar.open(res.message , 'Undo', {
            duration: 1000
          })
            // Do code error here miss arab...
          }
          // return res.data;
          return res.data;
        }
      ));
  }

  getCheckAuthToken() {
    return  this.http.get(`${this.baseUrl}/${this.routePrefix}/auth`).pipe(map(
      (res: any) => res.data
    ))
  }
  }

